import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { VideoTeasers, TrailerModal } from "@/components/landing/VideoTeasers";
import { ApparelSpotlight } from "@/components/landing/ApparelSpotlight";
import { CatalinaBanner } from "@/components/landing/CatalinaBanner";
import { CommunityHub } from "@/components/landing/CommunityHub";
import { Footer } from "@/components/landing/Footer";
import { SectionBoundary } from "@/components/SectionBoundary";
import { Seo } from "@/components/Seo";

export default function LandingPage() {
  const [trailer, setTrailer] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#070A0F] text-[#F7F8F9] min-h-screen overflow-x-clip" data-testid="landing-page">
      <Seo
        title="Captain's Cut — Maritime Reality Show & Apparel"
        description="Real maritime skills meet real challenges. Follow the crew, vote on captains, first mates and yachts, apply for the show, and shop Captain's Cut maritime apparel."
        path="/"
      />
      <Nav />
      <SectionBoundary name="hero">
        <Hero onWatch={() => setTrailer({ title: "CAPTAIN'S CUT — OFFICIAL TRAILER", tagline: "Can you make the cut?", image: "/assets/captain.png" })} />
      </SectionBoundary>
      <Marquee />
      <Manifesto />
      <SectionBoundary name="teasers"><VideoTeasers onWatch={setTrailer} /></SectionBoundary>
      <ApparelSpotlight />
      <CatalinaBanner />
      <SectionBoundary name="community"><CommunityHub onWatch={setTrailer} /></SectionBoundary>
      <Footer />
      <TrailerModal trailer={trailer} onClose={() => setTrailer(null)} />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
